(() => {
  const initStudio = (studio) => {
    if (!studio || studio.dataset.tlgStudioReady === 'true') return;
    studio.dataset.tlgStudioReady = 'true';

    const canvas = studio.querySelector('[data-tlg-canvas]');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const upload = studio.querySelector('[data-tlg-upload]');
    const status = studio.querySelector('[data-tlg-file-status]');
    const scaleInput = studio.querySelector('[data-tlg-scale]');
    const xInput = studio.querySelector('[data-tlg-x]');
    const yInput = studio.querySelector('[data-tlg-y]');
    const scaleProperty = studio.querySelector('[data-tlg-scale-property]');
    const positionProperty = studio.querySelector('[data-tlg-position-property]');
    const colorProperty = studio.querySelector('[data-tlg-color-property]');
    const colorInputs = studio.querySelectorAll('[data-tlg-color]');

    let artwork = null;
    let baseColor = '#f8f5ef';
    let baseColorName = 'Ivory cotton';

    const drawRoundedRect = (x, y, width, height, radius) => {
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      ctx.lineTo(x + width - radius, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
      ctx.lineTo(x + width, y + height - radius);
      ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
      ctx.lineTo(x + radius, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
      ctx.lineTo(x, y + radius);
      ctx.quadraticCurveTo(x, y, x + radius, y);
      ctx.closePath();
    };

    const drawTexture = (x, y, width, height) => {
      ctx.save();
      drawRoundedRect(x, y, width, height, 28);
      ctx.clip();

      ctx.strokeStyle = 'rgba(49, 92, 81, 0.08)';
      ctx.lineWidth = 2;

      for (let i = x + 28; i < x + width; i += 34) {
        ctx.beginPath();
        ctx.moveTo(i, y);
        ctx.lineTo(i, y + height);
        ctx.stroke();
      }

      for (let i = y + 28; i < y + height; i += 34) {
        ctx.beginPath();
        ctx.moveTo(x, i);
        ctx.lineTo(x + width, i);
        ctx.stroke();
      }

      ctx.fillStyle = 'rgba(255, 255, 255, 0.2)';
      for (let i = x + 18; i < x + width; i += 46) {
        for (let j = y + 18; j < y + height; j += 46) {
          ctx.beginPath();
          ctx.arc(i, j, 1.3, 0, Math.PI * 2);
          ctx.fill();
        }
      }

      ctx.restore();
    };

    const drawFringe = (x, y, width, height) => {
      ctx.strokeStyle = 'rgba(248, 245, 239, 0.9)';
      ctx.lineWidth = 4;

      const bottom = y + height;

      for (let i = x + 22; i < x + width - 20; i += 20) {
        ctx.beginPath();
        ctx.moveTo(i, bottom - 6);
        ctx.quadraticCurveTo(i + 5, bottom + 20, i - 1, bottom + 42);
        ctx.stroke();
      }
    };

    const updateProperties = () => {
      if (scaleProperty) scaleProperty.value = `${scaleInput?.value || 88}%`;

      if (positionProperty) {
        const x = Number(xInput?.value || 0);
        const y = Number(yInput?.value || 0);
        positionProperty.value = `X ${x}, Y ${y}`;
      }

      if (colorProperty) colorProperty.value = baseColorName;
    };

    const drawPlaceholder = (x, y, width, height) => {
      ctx.save();

      ctx.strokeStyle = 'rgba(49, 92, 81, 0.24)';
      ctx.setLineDash([14, 10]);
      ctx.lineWidth = 4;

      drawRoundedRect(
        x + width * 0.22,
        y + height * 0.22,
        width * 0.56,
        height * 0.5,
        22
      );
      ctx.stroke();

      ctx.setLineDash([]);

      ctx.fillStyle = '#315c51';
      ctx.font = '900 34px Arial, sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText('Upload artwork', x + width / 2, y + height * 0.46);

      ctx.fillStyle = '#65766f';
      ctx.font = '500 22px Arial, sans-serif';
      ctx.fillText('Preview your design on towel', x + width / 2, y + height * 0.54);

      ctx.restore();
    };

    const drawArtwork = (x, y, width, height) => {
      if (!artwork) {
        drawPlaceholder(x, y, width, height);
        return;
      }

      const scale = Number(scaleInput?.value || 88) / 100;
      const offsetX = Number(xInput?.value || 0) / 100;
      const offsetY = Number(yInput?.value || 0) / 100;

      const maxW = width * 0.72 * scale;
      const maxH = height * 0.62 * scale;
      const ratio = Math.min(maxW / artwork.width, maxH / artwork.height);

      const drawW = artwork.width * ratio;
      const drawH = artwork.height * ratio;
      const drawX = x + width / 2 - drawW / 2 + offsetX * width * 0.28;
      const drawY = y + height / 2 - drawH / 2 + offsetY * height * 0.28;

      ctx.save();
      ctx.shadowColor = 'rgba(36, 60, 53, 0.14)';
      ctx.shadowBlur = 24;
      ctx.shadowOffsetY = 12;
      ctx.drawImage(artwork, drawX, drawY, drawW, drawH);
      ctx.restore();
    };

    const draw = () => {
      const width = canvas.width || 1200;
      const height = canvas.height || 820;

      ctx.clearRect(0, 0, width, height);

      const bg = ctx.createLinearGradient(0, 0, width, height);
      bg.addColorStop(0, '#dde9ea');
      bg.addColorStop(1, '#f8f5ef');

      ctx.fillStyle = bg;
      ctx.fillRect(0, 0, width, height);

      const towelX = 150;
      const towelY = 84;
      const towelW = 900;
      const towelH = 610;

      ctx.save();
      ctx.shadowColor = 'rgba(36, 60, 53, 0.16)';
      ctx.shadowBlur = 34;
      ctx.shadowOffsetY = 18;

      drawRoundedRect(towelX, towelY, towelW, towelH, 28);
      ctx.fillStyle = baseColor;
      ctx.fill();

      ctx.restore();

      drawTexture(towelX, towelY, towelW, towelH);
      drawArtwork(towelX, towelY, towelW, towelH);
      drawFringe(towelX, towelY, towelW, towelH);

      ctx.fillStyle = '#315c51';
      ctx.font = '900 24px Arial, sans-serif';
      ctx.textAlign = 'left';
      ctx.fillText('Towel Lify Gifts', 62, 56);

      updateProperties();
    };

    upload?.addEventListener('change', (event) => {
      const file = event.target.files?.[0];

      if (!file) {
        artwork = null;
        if (status) status.textContent = 'No artwork uploaded';
        draw();
        return;
      }

      if (!file.type.startsWith('image/')) {
        artwork = null;
        upload.value = '';
        if (status) status.textContent = 'Please upload an image file';
        draw();
        return;
      }

      const reader = new FileReader();

      reader.onload = () => {
        const image = new Image();

        image.onload = () => {
          artwork = image;

          if (status) {
            status.textContent =
              file.name.length > 28 ? `${file.name.slice(0, 25)}...` : file.name;
          }

          draw();
        };

        image.src = reader.result;
      };

      reader.readAsDataURL(file);
    });

    colorInputs.forEach((input) => {
      input.addEventListener('change', () => {
        baseColor = input.dataset.tlgColor || '#f8f5ef';
        baseColorName = input.dataset.tlgColorName || input.value || 'Ivory cotton';
        draw();
      });
    });

    [scaleInput, xInput, yInput].forEach((input) => {
      input?.addEventListener('input', draw);
    });

    draw();
  };

  const initAll = () => {
    document.querySelectorAll('[data-tlg-print-studio]').forEach(initStudio);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-tlg-print-studio]').forEach(initStudio);
  });
})();